import { hydrate } from 'react-dom';
import App from 'Containers/App';
import getServerState from '../../tools/getPreloadedState';
import { IServerDataBase } from 'Src/store/context/types';
import { initDWHLogger } from 'Tools/dwhLogger';
import tracerInit from 'Tools/tracer';
import { getWorker } from '@media-ui/core/src/tools/swInstaller';
// Инициализация DWH логера
void initDWHLogger();
tracerInit();
const { ready } = window.promisifiedDomEvents;
void ready.then(async (): Promise<void> => {
    void getWorker({
        workerKey: 'sw-common',
        workers: {
            'sw-common': `/sw-common.js`,
        },
    });
    const context = await getServerState<IServerDataBase>('Pets');
    hydrate(<App context={context}/>, document.querySelector('#root-Pets'));
});
